import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppSettingsTrainingPage } from './app-settings-training';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppSettingsTrainingPage,
  ],
  imports: [
    IonicPageModule.forChild(AppSettingsTrainingPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppSettingsTrainingPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-settings-training/app-settings-training.module.ts